import type { UiSchema } from "@rjsf/core"

export type FileType =
    | "image"
    | "audio"
    | "video"
    | "satellite"
    | "document"
    | "imageAndDocument"

export function fromMimeType(mimeType: string): FileType | undefined {
    return mimeType.match(/image\/(geo)?tiff?/) !== null
        ? "satellite"
        : mimeType.startsWith("image/")
        ? "image"
        : mimeType.startsWith("video/")
        ? "video"
        : mimeType.startsWith("audio/")
        ? "audio"
        : mimeType === "application/pdf"
        ? "document"
        : undefined
}

export function toAcceptedMimeType(type: FileType): string {
    switch (type) {
        case "image":
            return "image/*"
        case "audio":
            return "audio/*"
        case "video":
            return "video/*"
        case "satellite":
            return "image/geotiff,.tif,.tiff,.geotiff"
        case "document":
            return "application/pdf"
        case "imageAndDocument":
            return "application/pdf,image/*"
        default:
            return ""
    }
}

export function fromUiSchema(uiSchema: UiSchema): FileType | undefined {
    switch (uiSchema?.["ui:field"]) {
        case "https://widgets.super.ai/image@1":
            return "image"
        case "https://widgets.super.ai/audio@0.0.4":
            return "audio"
        case "https://widgets.super.ai/video@0.0.4":
            return "video"
        case "https://widgets.super.ai/satellite@0.0.4":
            return "satellite"
        case "https://widgets.super.ai/document@0.0.4":
            return "document"
        case "https://widgets.super.ai/img-document@0.0.4":
            return "imageAndDocument"
        default:
            return undefined
    }
}
